module.exports = __webpack_public_path__ + "img/icon-amex.5bae2f67.svg";